import { assetNotificationService } from '@afterpaytouch/portal-api/consumer/assetNotification'

export const { useSendNotificationMutation } = assetNotificationService
